import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import { Typography } from "@mui/material";

function CustomToolbar({ tableTitle, defaultExport = false }) {
  const DataGridCustomToolbar = () => {
    return (
      <GridToolbarContainer
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "1em",
          borderBottom: "1px solid lightgray",
          height: "4.2em",
        }}
      >
        <Typography variant="h6">{tableTitle}</Typography>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <>
            {defaultExport ? (
              <GridToolbarExport
                printOptions={{ disableToolbarButton: true }}
              />
            ) : (
              <div />
            )}
          </>
        </div>
      </GridToolbarContainer>
    );
  };
  return DataGridCustomToolbar;
}

const getDataGridToolbarProps = (tableTitle, exportOption = false) => {
  return CustomToolbar({
    tableTitle: tableTitle,
    defaultExport: exportOption,
  });
};
export default getDataGridToolbarProps;
